import { Grid } from "@mui/material";
import React from "react";
import Header from "../../common/Header";
import Footer from "../../common/Footer";
import DetailPageSection from "../sections/DetailPageSection";
import HeaderSec from "../../common/HeaderSec";
import RealReviews from "../sections/RealReviews";
import RelatedProducts from "../sections/RelatedProducts";
import DetailPageTestimonials from "../sections/DetailPageTestimonials";

const DetailPage = () => {
  return (
    <Grid>
      <Header />
      <HeaderSec />
      <DetailPageSection />
      <RealReviews />
      <RelatedProducts />
      <DetailPageTestimonials />
      <Footer />
    </Grid>
  );
};

export default DetailPage;
